module.exports = __webpack_public_path__ + "img/SMT_29_Mr_Benny_Yip.b989dc4b.jpg";